import { tokens } from '@cellula/react-theme-patient';
import styled from 'styled-components';

interface Props {
	children: string;
}

const elements = {
	container: styled.div`
		font: ${tokens.text.body.regular};
		white-space: pre-line;

		p {
			margin-bottom: ${tokens.spacing.x1};

			&:last-of-type {
				margin-bottom: 0;
			}
		}
	`,
};

export function Article({ children, ...rest }: Props): JSX.Element {
	const normalizedText = (children as unknown) instanceof String ? children : `${children}`;

	return (
		<elements.container {...rest}>
			{normalizedText.split('\n\n').map((section) => (
				<p key={section}>{section}</p>
			))}
		</elements.container>
	);
}
